import React from 'react'
import { cn } from './cn'

export interface SpinnerProps {
  size?: number
  className?: string
  label?: string
}

/** Indeterminate spinner in `currentColor`. */
export const Spinner = ({ size = 20, className, label = 'Loading' }: SpinnerProps) => (
  <svg
    role="status"
    aria-label={label}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={cn(
      'shrink-0 animate-spin motion-reduce:animate-[spin_1.6s_linear_infinite]',
      className
    )}
  >
    <circle cx="12" cy="12" r="9.5" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
    <path
      d="M21.5 12a9.5 9.5 0 0 0-9.5-9.5"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
)
